import Button from 'components/Forms/Button/Button';
import styled, { css } from 'styled-components';

type PromoCodeStyledProps = {
    contentElementHeight: number;
};

export const PromoCodeStyled = styled.div<PromoCodeStyledProps>(
    ({ contentElementHeight }) => css`
        margin-bottom: 30px;

        .promoCode-enter {
            height: 0;
        }

        .promoCode-enter-active {
            height: ${contentElementHeight}px;
            transition: 0.3s all ease;
        }

        .promoCode-exit {
            height: ${contentElementHeight}px;
        }

        .promoCode-exit-active {
            height: 0;
            transition: 0.3s all ease;
        }
    `,
);

export const PromoCodeContentWrapperStyled = styled.div(
    ({ theme }) => css`
        margin-left: -2px;
        padding: 2px;

        @media ${theme.mediaQueries.queryVl} {
            margin-left: 25px;
        }
    `,
);

export const PromoCodeContentStyled = styled.div`
    display: flex;
`;

export const PromoCodeContentButtonStyled = styled(Button)(
    ({ theme }) => css`
        white-space: nowrap;
        margin-left: 10px;

        border-radius: ${theme.radius.big};
    `,
);
